import React from 'react'
import ImageGrid from './ImageGrid'
import InfoDesc from './InfoDesc'
import { Link } from 'react-router-dom'
import { getUrl } from '../../../utils/routesDefinition'

const participant = props => {

  let { appState, participants } = props
    , columnSize = appState.itemSize
    , items = participants.items
      .map(item => ({ ...item, rand: Math.random() }))
      .sort((a, b) => a.value - b.value)
    , year = (new Date()).getFullYear()
    , personList = props.participants.items.map(item => ({ ...item, title: item.person, person: item.title, date: item.year }))

  if (appState.item === 6) items = items.filter((_, i) => i < 5)
  if (appState.item === 4) items = items.filter((_, i) => i < 3)
  if (appState.item === 2) items = items.filter((_, i) => i < 3)

  if (appState.item === 2) return <div id='participantes'>
    <div className='column no-top no-left no-right' style={{ height: (columnSize * 4) }}>
      <div className='row no-top' style={{ minHeight: (columnSize * 2) }}>
        <InfoDesc {...props} fullDescription={{ title: participants.title, paragraph: participants.description }} />
      </div>
      <div className='row' style={{ minHeight: (columnSize * 2) }}>
        <ImageGrid {...props} position='right' banner={participants.banner} />
      </div>
    </div>
    <div className='row no-top' style={{ flexWrap: 'wrap' }}>
      {
        items
          .map((item, index) => <Link to={`${getUrl('objectsPerson')}?id=${item.id}`} className={`item item-button column goal-border ${index % 2 === 0 ? 'no-left' : 'no-right'}`} key={index}
            style={{ maxWidth: '50%', width: columnSize, height: columnSize, }}
          >
            <div>
              <h2>{item.person}</h2>
              <h4>{item.title}</h4>
            </div>
            <div className='item-action-button'>
              <p className='font-button'>{item.date}</p>
              <span className="icon-search-05"></span>
            </div>
          </Link>)
      }
      <div className='item item-button goal-border no-left no-right' onClick={() => props.onShowParticipants(personList, participants.title, props.participants.years)} style={{ maxWidth: '50%', height: columnSize - 2, background: appState.colorTheme.secondary, width: columnSize, borderBottom: '2px solid black', borderLeft: '2px solid black' }} >
        <div>
          <h2>SHOW ALL</h2>
          <h4>{year}</h4>
        </div>
        <div className='item-action-button'>
          <p> </p>
          <span className="icon-search-03"></span>
        </div>
      </div>
    </div>

  </div>

  return <div id='participantes'>
    <div className='row no-top' style={{ height: (columnSize * 2) - 2 }}>
      <InfoDesc {...props} fullDescription={{ title: participants.title, paragraph: participants.description }} />
      <div style={{ height: columnSize * 2, width: 2, background: 'black' }} />
      <ImageGrid {...props} position='right' banner={participants.banner} />
    </div>
    <div className='row' style={{ height: (columnSize) }}>
      {
        items.map((item, index) => <Link to={`${getUrl('objectsPerson')}?id=${item.id}`} data-title={item.person} className={`item item-button column ${index === 0 ? 'no-left' : ''}`} key={index}
          style={{ width: columnSize + 2, height: columnSize, }}
        >
          <div>
            <h2>{item.person}</h2>
            <h4>{item.title}</h4>
          </div>
          <div className='item-action-button'>
            <p> </p>
            <span className="icon-search-05"></span>
          </div>
        </Link>)
      }
      <div onClick={() => props.onShowParticipants(personList, participants.title, props.participants.years)} className='item item-button no-bottom' data-title='SHOW ALL' style={{ height: columnSize - 2, background: appState.colorTheme.secondary, width: columnSize - 1, borderLeft: '1px solid black' }} >
        <div>
          <h2>SHOW ALL</h2>
          <h4>{year}</h4>
        </div>
        <div className='item-action-button'>
          <p> </p>
          <span className="icon-search-03"></span>
        </div>
      </div>
    </div>
  </div>
}

export default participant

// style={{ width: columnSize, height: columnSize - 2, borderRight: '2px solid black' }} 